module.exports = __webpack_public_path__ + "img/11.a30b7563.jpg";